import React, { useState } from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import ProjectLogo from './ProjectLogo';
import { DSTheme } from '../../styles/themes/types';
import { ApplicationInterface } from '../../interfaces/application';

const useStyles = makeStyles((theme: DSTheme) => ({
  projectList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    maxWidth: '400px',
    justifyContent: 'left',
    alignItems: 'center',
    flexWrap: 'wrap',
    maxHeight: '100px',
    overflowY: 'auto',
  },
  projectListItem: {
    marginRight: '10px',
  },
  transparentButton: {
    border: '1px solid transparent',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  projectsStackedBubble: {
    minHeight: '24px',
    minWidth: '24px',
    backgroundColor: '#ffffff',
    borderRadius: '50%',

    '& button': {
      minHeight: '24px',
      minWidth: '24px',
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      color: theme.palette.text.secondary,
      border: '1px solid transparent',
      fontWeight: 700,
      fontSize: '14px',
      borderRadius: '50%',
    },
  },
  arrow: {
    color: theme.palette.primary.contrastText,
    fontSize: '32px',
  },
  tooltipArrow: {
    marginRight: '-10px',
  },
  tooltip: {
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: '16px',
    color: theme.palette.text.tooltip,
    fontSize: '12px',
    lineHeight: '16px',
    padding: '32px',
    maxWidth: '166px',
    boxShadow: '0px 5px 45px rgba(0,0,0,0.18)',
  },
}));

type ProjectStackProps = {
  projects: ApplicationInterface[];
  onClick: (projectId: string) => void;
};

const DISPLAY_LIMIT = 4;

const ProjectStack: React.FC<ProjectStackProps> = ({ projects, onClick }) => {
  const classes = useStyles();
  const [displayAll, setDisplayAll] = useState(false);

  return (
    <ul className={classes.projectList}>
      {projects.slice(0, displayAll ? projects.length : DISPLAY_LIMIT).map((project) => (
        <li className={classes.projectListItem} key={project.info.applicationId}>
          <Tooltip
            title={`App name: ${project.info.name}`}
            placement="top-end"
            arrow
            classes={{
              arrow: classes.arrow,
              tooltip: classes.tooltip,
              tooltipArrow: classes.tooltipArrow,
            }}
          >
            <button
              onClick={() => onClick(project.info.applicationId as string)}
              className={classes.transparentButton}
            >
              <ProjectLogo
                alt={project.info.name}
                height="24"
                width="24"
                src={project.assets?.appLogoUrl?.contentUrl}
              />
            </button>
          </Tooltip>
        </li>
      ))}
      {projects.length > DISPLAY_LIMIT && !displayAll && (
        <li className={classes.projectsStackedBubble}>
          <button onClick={() => setDisplayAll(true)}>{`+${
            projects.length - DISPLAY_LIMIT
          }`}</button>
        </li>
      )}
    </ul>
  );
};

export default ProjectStack;
